export const generateValue = (list, item, seperator, increment) => {
    const index = list.indexOf(`${item}${seperator}${increment}`);

    if (index !== -1) {
        const _increment = increment + 1;
        return generateValue(list, item, seperator, _increment);
    }
    return `${item}${seperator}${increment}`;
};

export const generateUniqueValues = (key, value, seperator, _formElements) => {

    const values = _formElements.map((formElement) => { if (formElement.values) return formElement.values[key]; });
    return generateValue(values, value, seperator, 1);
};

export const updateObjectInListById = (list, id, object) => list.map((listItem) => ((listItem.id === id)
    ? { ...listItem, ...object } : listItem));
